var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5528_246122)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5528_246122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21783 14.2197C1.51072 13.9268 1.9856 13.9268 2.27849 14.2197L4.99816 16.9393L7.71782 14.2197C8.01071 13.9268 8.48559 13.9268 8.77848 14.2197C9.07137 14.5126 9.07137 14.9874 8.77848 15.2803L5.52849 18.5303C5.23559 18.8232 4.76072 18.8232 4.46783 18.5303L1.21783 15.2803C0.924937 14.9874 0.924937 14.5126 1.21783 14.2197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55224 7.26901C6.68781 5.76158 8.28253 4.66404 10.0961 4.14175C11.9097 3.61946 13.8439 3.70073 15.6073 4.37329C17.3707 5.04586 18.8677 6.2733 19.8728 7.87066C20.878 9.46803 21.3367 11.3488 21.18 13.2296C21.0233 15.1103 20.2596 16.8892 19.004 18.2982C17.7483 19.7072 16.0688 20.67 14.2184 21.0414C12.3681 21.4129 10.4471 21.1729 8.74495 20.3577C8.37137 20.1788 8.21358 19.7309 8.3925 19.3573C8.57142 18.9837 9.01931 18.8259 9.39289 19.0049C10.8017 19.6796 12.3917 19.8782 13.9232 19.5708C15.4547 19.2633 16.8449 18.4665 17.8841 17.3003C18.9234 16.1341 19.5555 14.6617 19.6852 13.105C19.8149 11.5483 19.4352 9.99165 18.6033 8.66953C17.7713 7.34742 16.5323 6.33149 15.0727 5.77481C13.6132 5.21814 12.0123 5.15088 10.5112 5.58317C9.01015 6.01546 7.69023 6.92388 6.75033 8.17155C5.81709 9.4104 5.30871 10.9171 5.30027 12.4675L5.74714 17.4328C5.78427 17.8453 5.47994 18.2099 5.06739 18.247C4.65484 18.2841 4.29031 17.9798 4.25318 17.5673L3.80318 12.5672C3.80115 12.5447 3.80014 12.522 3.80016 12.4994C3.80176 10.6121 4.41667 8.77644 5.55224 7.26901Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 7.75C12.9142 7.75 13.25 8.08579 13.25 8.5V12.4802L16.7633 13.7978C17.1512 13.9432 17.3477 14.3755 17.2022 14.7633C17.0568 15.1512 16.6245 15.3477 16.2367 15.2022L12.2367 13.7022C11.9439 13.5925 11.75 13.3126 11.75 13V8.5C11.75 8.08579 12.0858 7.75 12.5 7.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5528_246122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5528_246122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2132,
    height: 21.2132,
    fill: "white",
    transform: "translate(-2.5 12.5) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.4c603475f3cd3fec92114812cdd6b2b2.svg";
export { ForwardRef as ReactComponent };